import React from 'react';
import {
  FilterTableFrame,
} from '@gsa/afp-component-library';
import { MakeModelTable } from './make-model-table';
import MakeModelFilter from './make-model-table-filters';
import AddMakeModelButton from './add-make-model-button';


export default FilterTableFrame(
  null,
  AddMakeModelButton,
  MakeModelFilter,
  MakeModelTable,
);
